import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EllipsisVertical, Resolve } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo, useCallback, useMemo } from "react";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
import { QueryParamNames } from "~/constants/search";
import { DISCUSSION_COMMENT_MENU_TRIGGER, RESOLVE_DISCUSSION_BUTTON } from "~/constants/testIDs";
import { activeDiscussionIdParamSelector } from "~/store/router/selectors";
import { getDiscussionCommentMenuOptions } from "~/utils/menuOptions/getDiscussionCommentMenuOptions";
import { setQueryParams } from "~/utils/PathUtils";
import { useAirStore } from "~/utils/ReduxUtils";
export const CommentMenu = /*#__PURE__*/ memo((param)=>{
    let { onToggleResolve, onEdit, onDelete, discussion, comment } = param;
    const store = useAirStore();
    const handleDeleteClick = useCallback(()=>{
        onDelete === null || onDelete === void 0 ? void 0 : onDelete({
            comment,
            clipId: discussion.clipId,
            timestamp: discussion.timestamp,
            annotation: discussion.annotation
        });
        const activeDiscussionId = activeDiscussionIdParamSelector(store.getState());
        if (activeDiscussionId === discussion.id) {
            setQueryParams({
                [QueryParamNames.discussionId]: undefined
            }, "replace");
        }
    }, [
        comment,
        discussion,
        onDelete,
        store
    ]);
    const handleToggleResolveClick = useCallback(()=>{
        onToggleResolve === null || onToggleResolve === void 0 ? void 0 : onToggleResolve({
            clipId: discussion.clipId,
            timestamp: discussion.timestamp,
            annotation: discussion.annotation,
            id: discussion.id,
            resolved: !discussion.resolved
        });
    }, [
        discussion,
        onToggleResolve
    ]);
    const menuOptions = useMemo(()=>getDiscussionCommentMenuOptions({
            onDelete: onDelete ? handleDeleteClick : undefined,
            onEdit,
            onResolve: onToggleResolve ? handleToggleResolveClick : undefined
        }), [
        handleDeleteClick,
        handleToggleResolveClick,
        onDelete,
        onEdit,
        onToggleResolve
    ]);
    if (!menuOptions.length && !onToggleResolve) {
        return null;
    }
    const hasOnlyResolveInMenu = menuOptions.length === 1 && menuOptions[0].id === "resolve";
    return /*#__PURE__*/ _jsxs("div", {
        className: "comment-menu flex items-center",
        onClick: (event)=>event.stopPropagation(),
        children: [
            onToggleResolve && /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                "data-testid": RESOLVE_DISCUSSION_BUTTON,
                icon: Resolve,
                label: "Resolve discussion",
                onClick: handleToggleResolveClick,
                size: "small"
            }),
            menuOptions.length > 0 && !hasOnlyResolveInMenu && /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
                isTitleHidden: true,
                options: menuOptions,
                title: "More comment options",
                trigger: /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    color: "grey",
                    "data-testid": DISCUSSION_COMMENT_MENU_TRIGGER,
                    icon: EllipsisVertical,
                    label: "More options",
                    size: "small"
                })
            })
        ]
    });
});
CommentMenu.displayName = "CommentMenu";
